import React, { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { CalendarIcon, ChevronLeft, ChevronRight, X } from "lucide-react";

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// value = "YYYY-MM" (or "" for none)
export function MonthPicker({ value, onChange, testid, className }) {
  const [open, setOpen] = useState(false);
  const [year, setYear] = useState(value ? Number(value.slice(0, 4)) : new Date().getFullYear());
  const selYear = value ? Number(value.slice(0, 4)) : null;
  const selMonth = value ? Number(value.slice(5, 7)) : null;
  const label = value ? `${MONTHS[selMonth - 1]} ${value.slice(0, 4)}` : "All months";
  const pick = (m) => { onChange(`${year}-${String(m).padStart(2, "0")}`); setOpen(false); };
  return (
    <div className={`relative inline-block ${className || "w-44"}`}>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button variant="outline" data-testid={testid} className={`w-full justify-start font-normal ${value ? "pr-8" : ""}`}>
            <CalendarIcon className="mr-2 h-4 w-4 opacity-70 shrink-0" /><span className="truncate">{label}</span>
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-64 p-3" align="start">
          <div className="flex items-center justify-between mb-3">
            <button onClick={() => setYear((y) => y - 1)} className="p-1 rounded hover:bg-accent" data-testid={testid ? `${testid}-prev-year` : undefined}><ChevronLeft className="h-4 w-4" /></button>
            <span className="text-sm font-semibold">{year}</span>
            <button onClick={() => setYear((y) => y + 1)} className="p-1 rounded hover:bg-accent" data-testid={testid ? `${testid}-next-year` : undefined}><ChevronRight className="h-4 w-4" /></button>
          </div>
          <div className="grid grid-cols-3 gap-2">
            {MONTHS.map((m, i) => {
              const active = selMonth === i + 1 && selYear === year;
              return (
                <button key={m} data-testid={testid ? `${testid}-m${i + 1}` : undefined} onClick={() => pick(i + 1)}
                  className={`text-xs py-2 rounded-md transition-colors ${active ? "bg-primary text-white" : "text-muted-foreground hover:bg-accent"}`}>{m}</button>
              );
            })}
          </div>
        </PopoverContent>
      </Popover>
      {value && (
        <button
          type="button"
          data-testid={testid ? `${testid}-clear` : undefined}
          onClick={() => onChange("")}
          className="absolute right-2 top-1/2 -translate-y-1/2 z-10 text-muted-foreground hover:text-foreground"
          aria-label="Clear month"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      )}
    </div>
  );
}
